import { useState } from "react";
import { FormTextArea, FormSelect } from "../../../components/forms";
import { IconButton } from "../../../components";
import Skeleton from "react-loading-skeleton";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { openConfirmModal } from "../../../components/modals/ConfirmModal";

const ClientVulnerabilitiesRow = ({
    data,
    isLoading,
    error,
    vulnerabilityCategories,
    vulnerabilityCategoriesLoading,
    vulnerabilityCategoriesError,
    vulnerabilityTypeByCategory,
    vulnerabilityTypesLoading,
    vulnerabilityTypesError,
    clientOptions,
    clientLoading,
    clientError,
    onChange = () => { },
    onDelete = () => { },
    refetch = () => { }
}) => {

    const [category, setCategory] = useState(data?.category);
    const filteredTypes = vulnerabilityTypeByCategory.filter((type) => type.category === category);
    const isDataLoading = isLoading || vulnerabilityCategoriesLoading || vulnerabilityTypesLoading || clientLoading;
    const isError = error || vulnerabilityCategoriesError || clientError || vulnerabilityTypesError

    if (isDataLoading) return (
        <Skeleton height={30} count={2} />
    )
    if (isError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={refetch} />
        </ErrorMessageWrapper>;
    };
    if (!data || data.length < 1) {
        return null;
    }

    const onHandleDelete = async (vulnerabilityId, vulnerabilitySectionId) => {
        const confirm = await openConfirmModal({
            dialogTitle: "Delete Client Vulnerability?",
            message: "Are you sure you wish to delete this client vulnerability? "
        });
        if (confirm) {
            onDelete(vulnerabilityId, vulnerabilitySectionId);
        }
    }

    return (<>
        {isDataLoading ? <Skeleton height={30} count={2} /> :
            <>
                <FormSelect
                    defaultValue={data.category}
                    onChange={(category) => setCategory(category.value)}
                    onBlur={(category) => onChange(data.vulnerabilityId, "category", category.value)}
                    isLoadingOptions={vulnerabilityCategoriesLoading}
                    options={vulnerabilityCategories}
                />
                <FormSelect
                    defaultValue={data.vulnerabilityTypeId}
                    onBlur={(newValues) => onChange(data.vulnerabilityId, "vulnerabilityTypeId", newValues.value)}
                    isLoadingOptions={vulnerabilityTypesLoading}
                    options={filteredTypes}
                />
                <FormSelect
                    defaultValue={data.clientAccountId}
                    onBlur={(newValues) => onChange(data.vulnerabilityId, "clientAccountId", newValues.value)}
                    isLoadingOptions={clientLoading}
                    options={clientOptions}
                />
                <FormTextArea
                    value={data?.additionalInfo}
                    onBlur={(newValues) => onChange(data.vulnerabilityId, "additionalInfo", newValues)}
                />
                <IconButton
                    icon="trash-can"
                    variant="danger"
                    onClick={() => onHandleDelete(data.vulnerabilityId, data.vulnerabilitySectionId)}
                    disabled={isLoading || !data?.vulnerabilityId}
                />
            </>
        }
    </>
    )
}

export default ClientVulnerabilitiesRow;